import Tippy from '@tippyjs/react';
import moment from 'moment';
import numeral from 'numeral';
import { useCallback, useContext, useMemo, useState } from "react";
import { useQuery } from "react-query";
import { Link } from "react-router-dom";
import 'tippy.js/themes/light-border.css';
import { PageTitle } from "../../../../_metronic/layout/core";
import Semaphore from "../../../Components/Semaphore/Semaphore";
import WrappedAgTable from "../../../Components/Table/WrappedAgTable";
import { useGetUser } from "../../../Hooks/CustomHooks";
import { AddCartaFianza, GetGarantiasByRucContrato } from "../../../api/Api";
import { CELL_CONSTANTS, EXCEPCION_GARANTIA_ESTADO, EXCEPCION_GARANTIA_TIPO, GARANTIA_ESTADO, GARANTIA_TIPO } from '../../../pages/Utils/Constants';
import "./ListadoGarantiasLocatario.css";

import cogoToast from 'cogo-toast';
import { Badge } from 'react-bootstrap';
import CardEx from '../../../Components/Cards/CardEx';
import { SessionContext } from '../../../Components/Context/SessionContext';
import { createCustomDateFilterParams } from '../../../Components/Utils/Utils';
import GenerateRenovacionModal from './componentes/GenerateRenovacionModal';

export default function GarantiasLocatario({ title }) {
    const { session, setSession } = useContext(SessionContext);
    const { data: data_locatario, refetch: refetch_data_locatario } = useQuery("GetGarantiasByRuc",
        async () => await GetGarantiasByRucContrato(session.ruc, session.nroContrato),
        {
            enabled: !!session?.ruc && !!session?.nroContrato,
        }); //3001849 //3002384


    const header = useMemo(() => [
        {
            headerName: 'Id',
            field: 'detalle_garantia.id_garantia_detalle',
            pinned: 'left',
            width: 80
        },
        {
            headerName: 'Semáforos',
            field: 'semaforo_locatario',
            pinned: 'left',
            filter: false,
            sortable: false,
            width: 120,
            cellRenderer: (props) => props.data ? (
                <>
                    <div className="align-items-center d-flex h-100">
                        <Semaphore caption="LO" size={'25px'} fontSize={'11px'}
                            tooltipTitle={"Revisión de Locatario"}
                            lastUpdateDate={props.data.detalle_garantia?.revision_locatario?.fecha_revision}
                            lastUpdatedBy={props.data.detalle_garantia?.revision_locatario?.usuario_revisor}
                            tooltipDescription={props.data.detalle_garantia?.revision_locatario?.observaciones}
                            color={props.data.detalle_garantia.revision_locatario?.semaforo_color}>
                        </Semaphore>
                        <Semaphore caption="CO" size={'25px'} fontSize={'11px'}
                            tooltipTitle={"Revisión de Cobranza"}
                            lastUpdateDate={props.data.detalle_garantia?.revision_cobranza?.fecha_revision}
                            lastUpdatedBy={props.data.detalle_garantia?.revision_cobranza?.usuario_revisor}
                            tooltipDescription={props.data.detalle_garantia?.revision_cobranza?.observaciones}
                            color={props.data.detalle_garantia.revision_cobranza?.semaforo_color}>

                        </Semaphore>
                        {((props.data.detalle_garantia.tipo_garantia.codigo === GARANTIA_TIPO.GAR1_CARTA_FIANZA && !props.data.detalle_garantia.is_excepcion)
                            || (props.data.detalle_garantia.tipo_garantia.codigo === GARANTIA_TIPO.GAR0_EFECTIVO
                                && props.data.detalle_garantia.excepcion.codigo_tipo_excepcion === EXCEPCION_GARANTIA_TIPO.EFECTIVO_A_CARTA_FIANZA)) ?
                            (
                                <Semaphore caption="TE" size={'25px'} fontSize={'11px'}
                                    tooltipTitle={"Revisión de Tesorería"}
                                    lastUpdateDate={props.data.detalle_garantia?.revision_tesoreria?.fecha_revision}
                                    lastUpdatedBy={props.data.detalle_garantia?.revision_tesoreria?.usuario_revisor}
                                    tooltipDescription={props.data.detalle_garantia?.revision_tesoreria?.observaciones}
                                    color={props.data.detalle_garantia.revision_tesoreria?.semaforo_color}>
                                </Semaphore>
                            ) : null
                        }
                    </div>
                </>
            ) : <></>
        },
        {
            headerName: 'Acciones',
            filter: false,
            width: 100,
            pinned: 'left',
            sortable: false,
            cellRenderer: (props) => (
                <div className="d-flex align-items-center h-100 justify-content-center">
                    <Tippy theme='light-border' content="Ver detalle">
                        <Link to={`/garantias_view_locatario/${props.data.detalle_garantia.id_garantia_detalle}`} className="garantias-font d-flex align-items-center mx-2">
                            <i className="fi fi-rr-binoculars"></i>
                        </Link>
                    </Tippy>
                    {[GARANTIA_ESTADO.INGRESADO,
                    GARANTIA_ESTADO.PENDIENTE,
                    GARANTIA_ESTADO.RECHAZADO,
                    GARANTIA_ESTADO.INGRESADO_RENOVACION].includes(props.data.detalle_garantia.estado.codigo)
                        && (!props.data.detalle_garantia.is_excepcion || (props.data.detalle_garantia.is_excepcion && props.data.detalle_garantia.excepcion.codigo_estado_excepcion === EXCEPCION_GARANTIA_ESTADO.APROBADO.CODE))
                        &&
                        <Tippy theme='light-border' content="Revisar información">
                            <Link to={`/actualizar_garantia/${props.data.detalle_garantia.id_garantia_detalle}`} className="garantias-font d-flex align-items-center mx-2">
                                <i className="fi-rr-edit"></i>
                            </Link>
                        </Tippy>}

                    {(props.data.detalle_garantia.estado.codigo === GARANTIA_ESTADO.EN_REQUERIMIENTO || (props.data.detalle_garantia.en_ventana_renovacion && props.data.detalle_garantia.estado.codigo === GARANTIA_ESTADO.APROBADO)) &&
                        <Tippy theme='light-border' content="Renovar Carta Fianza">
                            <button className="btn btn-link garantias-font d-flex align-items-center mx-2"
                                onClick={() => openGenerateModal(props)}>
                                <i className="fi fi-rr-envelope-open-text"></i>
                            </button>
                        </Tippy>}
                </div>
            )
        },
        {
            headerName: 'Contrato',
            field: 'garantia.nro_contrato',
            width: 120,
            pinned: 'left',
            filter: 'agTextColumnFilter',
        },
        {
            headerName: 'Recepcionada?',
            field: 'detalle_garantia.is_recepcionada',
            width: 120,
            cellRenderer: (props) => {
                if (!props.data) {
                    return <></>;
                }
                var element = '';
                if (props.data.detalle_garantia.is_recepcionada === true) {
                    element = <Badge bg="" style={{ backgroundColor: props.data.detalle_garantia.recepcion?.semaforo_color }} >Si Recepcionada</Badge>
                }
                else if (props.data.detalle_garantia.is_recepcionada === false) {
                    element = <Badge bg="" style={{ backgroundColor: props.data.detalle_garantia.recepcion?.semaforo_color }} >No Recepcionada</Badge>
                } else {
                    element = <Badge bg="secondary">No Recepcionada</Badge>

                }

                return <div className="align-items-center d-flex h-100">{element}</div>
            },
        },
        {
            headerName: 'Renovada?',
            field: 'detalle_garantia.is_renovada',
            width: 100,
            //columnGroupShow: 'open',
            cellRenderer: (props) => {
                if (!props.data) {
                    return <></>;
                }
                let element = '';
                if (props.data.detalle_garantia.is_renovada === true) {
                    element = <Badge bg="danger">Si Renovada</Badge>
                } else {
                    element = <Badge bg="secondary">No Renovada</Badge>
                }
                return <div className="align-items-center d-flex h-100">{element}</div>;
            },
        },
        {
            headerName: 'Requerida?',
            field: 'detalle_garantia.is_requerida',
            width: 100,
            //columnGroupShow: 'open',
            cellRenderer: (props) => {
                if (!props.data) {
                    return <></>;
                }
                let element = '';
                if (props.data.detalle_garantia.is_requerida === true) {
                    element = <Badge bg="danger">Si Requerida</Badge>;
                } else {
                    element = <Badge bg="secondary">No Requerida</Badge>;
                }
                return <div className="align-items-center d-flex h-100">{element}</div>;
            },
        },
        {
            headerName: 'Desistida?',
            field: 'detalle_garantia.is_desistida',
            width: 100,
            //columnGroupShow: 'open',
            cellRenderer: (props) => {
                if (!props.data) {
                    return <></>;
                }
                let element = '';
                if (props.data.detalle_garantia.is_desistida === true) {
                    element = <Badge bg="danger">Si Desistida</Badge>;
                } else {
                    element = <Badge bg="secondary">No Desistida</Badge>;
                }
                return <div className="align-items-center d-flex h-100">{element}</div>;
            }
        },
        {
            headerName: 'Ejecutada?',
            field: 'detalle_garantia.is_ejecutada',
            width: 100,
            //columnGroupShow: 'open',
            cellRenderer: (props) => {
                if (!props.data) {
                    return <></>;
                }
                let element = '';
                if (props.data.detalle_garantia.is_ejecutada === true) {
                    element = <Badge bg="danger">Si Ejecutada</Badge>;
                } else {
                    element = <Badge bg="secondary">No Ejecutada</Badge>;
                }
                return <div className="align-items-center d-flex h-100">{element}</div>;
            }
        },
        {
            headerName: 'Excepción?',
            field: 'detalle_garantia.is_excepcion',
            width: 100,
            cellRenderer: (props) => {
                if (!props.data) {
                    return <></>;
                }
                let element = '';
                if (props.data.detalle_garantia.is_excepcion === true) {
                    element = <Badge bg="danger">Con Excepción</Badge>;
                } else {
                    element = <Badge bg="secondary">Sin Excepción</Badge>;
                }
                return <div className="align-items-center d-flex h-100">{element}</div>;
            }
        },
        {
            headerName: 'Datos Generales',
            stickyLabel: false,
            children: [
                {
                    headerName: 'Origen',
                    field: 'detalle_garantia.origen.nombre',
                    width: 110
                },
                {
                    headerName: 'Estado',
                    field: 'detalle_garantia.estado.nombre',
                    width: 110,
                    cellRenderer: (props) => {
                        if (!props.data) {
                            return <></>;
                        }
                        let element = '';
                        if (props.data.detalle_garantia.estado.codigo === GARANTIA_ESTADO.RECHAZADO) {
                            element = <Badge bg="danger">{props.data.detalle_garantia.estado.nombre}</Badge>;
                        } else if (props.data.detalle_garantia.estado.codigo === GARANTIA_ESTADO.EN_REVISION) {
                            element = <Badge bg="info">{props.data.detalle_garantia.estado.nombre}</Badge>;
                        } else if (props.data.detalle_garantia.estado.codigo === GARANTIA_ESTADO.APROBADO) {
                            element = <Badge bg="success">{props.data.detalle_garantia.estado.nombre}</Badge>;
                        } else {
                            element = <Badge bg="secondary">{props.data.detalle_garantia.estado.nombre}</Badge>;
                        }
                        return <div className="align-items-center d-flex h-100">{element}</div>;
                    }
                },
                {
                    headerName: 'Tipo',
                    width: 120,
                    field: 'detalle_garantia.tipo_garantia.nombre',
                    //columnGroupShow: 'open',
                },

                {
                    headerName: 'RUC',
                    field: 'garantia.ruc',
                    width: 120,
                    filter: 'agTextColumnFilter',
                    //columnGroupShow: 'open',
                },
                {
                    headerName: 'Razon Social',
                    field: 'garantia.razon_social',
                    filter: 'agTextColumnFilter',
                    //columnGroupShow: 'open',
                },
                {
                    headerName: 'Mall',
                    field: 'garantia.mall.nombre',
                    width: 160,
                    //columnGroupShow: 'open',
                },
                {
                    headerName: 'Banco',
                    width: 100,
                    field: 'detalle_garantia.banco.codigo',
                    //columnGroupShow: 'open',
                },
                {
                    headerName: 'Importe',
                    field: 'detalle_garantia.importe',
                    type: 'rightAligned',
                    width: 100,
                    filter: 'agTextColumnFilter',
                    //columnGroupShow: 'open',
                    valueFormatter: function (params) {
                        return params.value ? `${numeral(params.value).format('0,0.00')}` : ``;
                    },
                },
                {
                    headerName: 'Moneda',
                    field: 'garantia.moneda.codigo',
                    width: 100,

                },
                {
                    headerName: 'Tipo Carta Fianza',
                    field: 'detalle_garantia.descripcion_tipo_carta_fianza',
                    type: 'rightAligned',
                    width: 100,
                    //filter: 'agTextColumnFilter',
                    //columnGroupShow: 'open',
                    
                },
            ]
        },
        {
            headerName: 'Carta Fianza',
            stickyLabel: true,
            children: [
                {
                    headerName: 'Nro.Carta Fianza',
                    width: 160,
                    field: 'detalle_garantia.nro_carta_fianza',
                    filter: 'agTextColumnFilter',
                    filterParams: {
                        textCustomComparator: function (filter, value, filterText) {
                            console.info(value, "<-------------value");

                        },
                    },
                    valueFormatter: function (params) {
                        return params.value == null ? CELL_CONSTANTS.NO_APLICA : params.value;
                    },
                    cellRenderer: (props) => {
                        const cellValue = props.valueFormatted ? props.valueFormatted : props.value;

                        if (cellValue == CELL_CONSTANTS.NO_APLICA) {
                            return <span className='cell-value-not-apply'>{cellValue}</span>
                        } else {
                            //return cellValue;
                            return <a href={props.data.detalle_garantia.url_filename_carta_fianza} className="link-custom-blue d-flex align-items-center mx-2" target="_blank" rel="noreferrer">
                                <span>{props.data.detalle_garantia.nro_carta_fianza}</span>
                            </a>;
                        }

                        // if (!props.data) {
                        //     return <></>;
                        // }

                    }
                },
                {
                    headerName: 'Venc.Carta Fianza',
                    field: 'detalle_garantia.fecha_vencimiento_carta_fianza',
                    filter: 'agDateColumnFilter',
                    filterParams: createCustomDateFilterParams,
                    valueFormatter: function (params) {
                        return (params.value) ? `${moment(params.value).format("DD/MM/yyyy")}` : null;
                    },
                    width: 150,
                    cellClass: 'date'
                },
            ]
        },
        {
            headerName: 'Efectivo',
            stickyLabel: true,
            children: [
                {
                    headerName: 'Nro Operación',
                    field: 'detalle_garantia.nro_operacion',
                    with: 120,
                    filter: 'agTextColumnFilter',
                    enableRowGroup: false,
                    filterValueGetter: (props) => {
                        try {
                            console.info(props);
                            if (props == undefined || props.data == undefined) return null;
                            console.info(props.getValue());
                            if (props.data.detalle_garantia.tipo_garantia.codigo == GARANTIA_TIPO.GAR1_CARTA_FIANZA) {
                                return CELL_CONSTANTS.NO_APLICA;
                            } else {
                                //return props.value;
                                return props.data.detalle_garantia.nro_operacion;
                            }
                        } catch (error) {
                            debugger;
                        }
                    },
                    cellRenderer: (props) => {
                        try {
                            if (props == undefined || props.data == undefined) return null;
                            const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
                            if (props.data.detalle_garantia.tipo_garantia.codigo == GARANTIA_TIPO.GAR1_CARTA_FIANZA) {
                                return <span className='cell-value-not-apply'>{CELL_CONSTANTS.NO_APLICA}</span>;
                            } else {
                                //return props.value;
                                //return cellValue;
                                return <a href={props.data.detalle_garantia.url_filename_operacion} className="link-custom-blue d-flex align-items-center mx-2" target="_blank" rel="noreferrer">
                                    <span>{props.data.detalle_garantia.nro_operacion}</span>
                                </a>;
                            }
                        } catch (error) {
                            debugger;
                        }

                    },

                }
            ]
        },
        {
            headerName: 'Recepción',
            stickyLabel: true,
            children: [
                // {
                //     headerName: 'Recepcionada?',
                //     field: 'detalle_garantia.is_recepcionada',
                //     width: 140,
                //     cellRenderer: (props) => {
                //         if (!props.data) {
                //             return <></>;
                //         }
                //         var element = '';
                //         if (props.data.detalle_garantia.is_recepcionada === true) {
                //             element = <Badge pill bg="" style={{ backgroundColor: props.data.detalle_garantia.recepcion?.semaforo_color }} >Si Recepcionada</Badge>
                //         }
                //         else if (props.data.detalle_garantia.is_recepcionada === false) {
                //             element = <Badge pill bg="" style={{ backgroundColor: props.data.detalle_garantia.recepcion?.semaforo_color }} >No Recepcionada</Badge>
                //         } else {
                //             element = <Badge pill bg="secondary">No Recepcionada</Badge>
                //         }

                //         return <div className="align-items-center d-flex h-100">{element}</div>
                //     },
                // },
                {
                    headerName: 'Semáforo',
                    field: 'detalle_garantia.recepcion.semaforo_color',
                    width: 70,
                    cellRenderer: (props) => props.data ? (<div className="align-items-center d-flex h-100">
                        <Semaphore
                            prefixMessage="Recepción registrada el"
                            caption=""
                            size={'25px'}
                            fontSize={'11px'}
                            tooltipTitle={"Recepción"}
                            lastUpdateDate={props.data.detalle_garantia?.recepcion?.creation_date}
                            lastUpdatedBy={props.data.detalle_garantia?.recepcion?.creation_by}
                            tooltipDescription={props.data.detalle_garantia.recepcion?.descripcion_recepcion_estado}
                            color={props.data.detalle_garantia.recepcion?.semaforo_color}>
                        </Semaphore>
                    </div>) : <></>
                },
                {
                    headerName: 'Fec.Recepción',
                    field: 'detalle_garantia.recepcion.creation_date',
                    filter: 'agDateColumnFilter',
                    filterParams: createCustomDateFilterParams,
                    valueFormatter: function (params) {
                        return (params.value) ? `${moment(params.value).format("DD/MM/yyyy")}` : null;
                    },
                    width: 150,
                    cellClass: 'date'
                },
                {
                    headerName: 'Fec.Ing.Cuenta',
                    field: 'detalle_garantia.recepcion.fecha_ingreso_cuenta',
                    filter: 'agDateColumnFilter',
                    filterParams: createCustomDateFilterParams,
                    valueFormatter: function (params) {
                        return (params.value) ? `${moment(params.value).format("DD/MM/yyyy")}` : null;
                    },
                    width: 150,
                    cellClass: 'date'
                },

            ]
        },
        {
            headerName: 'Renovación CF',
            stickyLabel: true,
            children: [
                // {
                //     headerName: 'Renovada?',
                //     field: 'detalle_garantia.is_renovada',
                //     width: 120,
                //     columnGroupShow: 'open',
                //     cellRenderer: (props) => {
                //         if (!props.data) {
                //             return <></>;
                //         }
                //         let element = '';
                //         if (props.data.detalle_garantia.is_renovada === true) {
                //             element = <Badge pill bg="danger">Si Renovada</Badge>
                //         } else {
                //             element = <Badge pill bg="secondary">No Renovada</Badge>
                //         }
                //         return <div className="align-items-center d-flex h-100">{element}</div>;
                //     },
                // },
                // {
                //     headerName: 'Ir',
                //     field: 'detalle_garantia.is_renovada',
                //     width: 40,
                //     filter: false,
                //     sortable: false,
                //     columnGroupShow: 'open',
                //     cellRenderer: (props) => {
                //         if (!props.data) {
                //             return <></>;
                //         }
                //         if (props.data.detalle_garantia.is_renovada === true) {
                //             return <div className="d-flex align-items-center h-100 justify-content-center">
                //                 <button className="btn btn-link garantias-font d-flex align-items-center mx-2" onClick={() => handleGoToTargetRenovacion(props)} >
                //                     <i className="fi fi-rr-sledding"></i>
                //                 </button>
                //             </div>
                //         } else {
                //             return <></>;
                //         }
                //     },
                // }
            ]
        },
        {
            headerName: 'Requerimiento CF',
            stickyLabel: true,
            children: [
                // {
                //     headerName: 'Requerida?',
                //     field: 'detalle_garantia.is_requerida',
                //     width: 120,
                //     //columnGroupShow: 'open',
                //     cellRenderer: (props) => {
                //         if (!props.data) {
                //             return <></>;
                //         }
                //         let element = '';
                //         if (props.data.detalle_garantia.is_requerida === true) {
                //             element = <Badge pill bg="danger">Si Requerida</Badge>;
                //         } else {
                //             element = <Badge pill bg="secondary">No Requerida</Badge>;
                //         }
                //         return <div className="align-items-center d-flex h-100">{element}</div>;
                //     },
                // },
                {
                    headerName: 'Fecha. Req.',
                    field: 'detalle_garantia.requerimiento.creation_date',
                    width: 150,
                    sortable: true,
                    //columnGroupShow: 'open',
                    filter: 'agDateColumnFilter',
                    filterParams: createCustomDateFilterParams,
                    valueFormatter: function (params) {
                        return (params.value) ? `${moment(params.value).format("DD/MM/yyyy")}` : null;
                    },
                    cellClass: 'date'
                },
                {
                    headerName: 'Nro.Carta Req.',
                    field: 'detalle_garantia.requerimiento.nro_carta_requerimiento',
                    width: 140,
                    sortable: true,
                    //columnGroupShow: 'open',
                    filter: 'agTextColumnFilter',
                    cellRenderer: (props) => {
                        if (!props.data) {
                            return <></>;
                        }
                        return <a href={props.data.detalle_garantia.requerimiento.url_file_name_carta_requerimiento} className="link-custom-blue d-flex align-items-center mx-2" target="_blank" rel="noreferrer">
                            <span>{props.data.detalle_garantia.requerimiento.nro_carta_requerimiento}</span>
                        </a>;
                    }
                }
            ]
        },
        {
            headerName: 'Desistimiento CF',
            stickyLabel: true,
            children: [
                // {
                //     headerName: 'Desistida?',
                //     field: 'detalle_garantia.is_desistida',
                //     width: 120,
                //     columnGroupShow: 'open',
                //     cellRenderer: (props) => {
                //         if (!props.data) {
                //             return <></>;
                //         }
                //         let element = '';
                //         if (props.data.detalle_garantia.is_desistida === true) {
                //             element = <Badge pill bg="danger">Si Desistida</Badge>;
                //         } else {
                //             element = <Badge pill bg="secondary">No Desistida</Badge>;
                //         }
                //         return <div className="align-items-center d-flex h-100">{element}</div>;
                //     }
                // },
                {
                    headerName: 'Nro.Carta Desis.',
                    field: 'detalle_garantia.desistimiento.nro_carta_desistimiento',
                    width: 140,
                    sortable: true,
                    columnGroupShow: 'open',
                    filter: 'agTextColumnFilter',
                    cellRenderer: (props) => {
                        if (!props.data) {
                            return <></>;
                        }
                        return <a href={props.data.detalle_garantia.desistimiento.url_file_name_carta_desistimiento} className="link-custom-blue d-flex align-items-center mx-2" target="_blank" rel="noreferrer">
                            <span>{props.data.detalle_garantia.desistimiento.nro_carta_desistimiento}</span>
                        </a>;
                    }
                },
                {
                    headerName: 'Fecha Entrega',
                    field: 'detalle_garantia.desistimiento.fecha_entrega',
                    columnGroupShow: 'open',
                    filter: 'agDateColumnFilter',
                    filterParams: createCustomDateFilterParams,
                    valueFormatter: function (params) {
                        return (params.value) ? `${moment(params.value).format("DD/MM/yyyy")}` : null;
                    },
                    width: 150,
                    cellClass: 'date'
                },
                {
                    headerName: 'Estado',
                    columnGroupShow: 'open',
                    field: 'detalle_garantia.desistimiento.nombre_estado_entrega',
                    width: 120
                }
            ]
        },
        {
            headerName: 'Ejecucion CF',
            stickyLabel: true,
            children: [
                // {
                //     headerName: 'Ejecutada?',
                //     field: 'detalle_garantia.is_ejecutada',
                //     width: 120,
                //     columnGroupShow: 'open',
                //     cellRenderer: (props) => {
                //         if (!props.data) {
                //             return <></>;
                //         }
                //         let element = '';
                //         if (props.data.detalle_garantia.is_ejecutada === true) {
                //             element = <Badge pill bg="danger">Si Ejecutada</Badge>;
                //         } else {
                //             element = <Badge pill bg="secondary">No Ejecutada</Badge>;
                //         }
                //         return <div className="align-items-center d-flex h-100">{element}</div>;
                //     }
                // },
                {
                    headerName: 'Fec.Venc.Prórroga',
                    field: 'detalle_garantia.ejecucion.fecha_vencimiento_prorroga',
                    width: 140,
                    filter: 'agDateColumnFilter',
                    filterParams: createCustomDateFilterParams,
                    sortable: true,
                    columnGroupShow: 'open',
                    valueFormatter: function (params) {
                        return (params.value) ? `${moment(params.value).format("DD/MM/yyyy")}` : null;
                    },
                    cellClass: 'date'
                },
                {
                    headerName: 'Nro.Carta Ejecu.',
                    field: 'detalle_garantia.ejecucion.nro_carta_ejecucion',
                    width: 140,
                    sortable: true,
                    columnGroupShow: 'open',
                    filter: 'agTextColumnFilter',
                    cellRenderer: (props) => {
                        if (!props.data) {
                            return <></>;
                        }
                        return <a href={props.data.detalle_garantia.ejecucion.url_file_name_carta_ejecucion} className="link-custom-blue d-flex align-items-center mx-2" target="_blank" rel="noreferrer">
                            <span>{props.data.detalle_garantia.ejecucion.nro_carta_ejecucion}</span>
                        </a>;
                    }
                },
                {
                    headerName: 'Fec.Entrega Carta',
                    field: 'detalle_garantia.ejecucion.fecha_entrega',
                    columnGroupShow: 'open',
                    filter: 'agDateColumnFilter',
                    filterParams: createCustomDateFilterParams,
                    valueFormatter: function (params) {
                        return (params.value) ? `${moment(params.value).format("DD/MM/yyyy")}` : null;
                    },
                    width: 150,
                    cellClass: 'date'
                },
                {
                    headerName: 'Estado',
                    columnGroupShow: 'open',
                    field: 'detalle_garantia.ejecucion.nombre_estado_entrega',
                    width: 120
                },
                {
                    headerName: 'Nro.Cheque',
                    columnGroupShow: 'open',
                    field: 'detalle_garantia.ejecucion.nro_cheque',
                    filter: 'agTextColumnFilter',
                    width: 120
                },
                {
                    headerName: 'Banco Cheque',
                    columnGroupShow: 'open',
                    field: 'detalle_garantia.ejecucion.codigo_banco_cheque',
                    width: 120
                },
                {
                    headerName: 'Fec.Ing.Cheque',
                    field: 'detalle_garantia.ejecucion.fecha_ingreso_cheque',
                    columnGroupShow: 'open',
                    filter: 'agDateColumnFilter',
                    filterParams: createCustomDateFilterParams,
                    valueFormatter: function (params) {
                        return (params.value) ? `${moment(params.value).format("DD/MM/yyyy")}` : null;
                    },
                    width: 150,
                    cellClass: 'date'
                },
            ]
        },
        {
            headerName: "Entrega Carta Fianza",
            stickyLabel: true,
            children: [
                {
                    headerName: 'Momento Entrega',
                    field: 'detalle_garantia.recepcion.descripcion_momento_entrega_carta_fianza',
                    width: 160,
                },
                {
                    headerName: 'Sustento',
                    field: 'detalle_garantia.recepcion.url_file_name_sustento_entrega_carta_fianza',
                    width: 150,
                    cellRenderer: (props) => {
                        if (!props.data) {
                            return <></>;
                        }
                        return <a href={props.data.detalle_garantia.recepcion.url_file_name_sustento_entrega_carta_fianza} className="link-custom-blue d-flex align-items-center mx-2" target="_blank" rel="noreferrer">
                            <span>{props.data.detalle_garantia.recepcion.file_name_sustento_entrega_carta_fianza}</span>
                        </a>;
                    }
                },
            ]
        },
        {
            headerName: "Excepcion de Garantía",
            stickyLabel: true,
            children: [
                // {
                //     headerName: 'Excepcion?',
                //     field: 'detalle_garantia.is_excepcion',
                //     width: 140,
                //     cellRenderer: (props) => {
                //         if (!props.data) {
                //         return <></>;
                //         }
                //         let element = '';
                //         if (props.data.detalle_garantia.is_excepcion) {
                //         element = <Badge pill bg="danger">Con Excepción</Badge>
                //         }
                //         else {
                //         element = <Badge pill bg="secondary">Sin Excepción</Badge>
                //         }

                //         return <div className="align-items-center d-flex h-100">{element}</div>
                //     },
                // },
                {
                    headerName: 'Tipo',
                    field: 'detalle_garantia.excepcion.nombre_tipo_excepcion',
                    width: 160,
                },
                {
                    headerName: 'Estado',
                    field: 'detalle_garantia.excepcion.nombre_estado_excepcion',
                    width: 120,
                },
                {
                    headerName: 'Importe',
                    field: 'detalle_garantia.excepcion.importe',
                    width: 100,
                    type: 'rightAligned',
                    filter: 'agNumberColumnFilter',
                    valueFormatter: function (params) {
                        return params.value ? `${numeral(params.value).format('0,0.00')}` : ``;
                    },
                },
                {
                    headerName: 'Fec.Vecimiento',
                    field: 'detalle_garantia.excepcion.fecha_vencimiento',
                    width: 150,
                    sortable: true,
                    filter: 'agDateColumnFilter',
                    filterParams: createCustomDateFilterParams,
                    valueFormatter: function (params) {
                        return (params.value) ? `${moment(params.value).format("DD/MM/yyyy")}` : null;
                    },
                    cellClass: 'date'
                },
                {
                    headerName: 'Sustento',
                    field: 'detalle_garantia.excepcion.file_name_adjunto',
                    width: 150,
                    cellRenderer: (props) => {
                        if (!props.data) {
                            return <></>;
                        }
                        return <a href={props.data.detalle_garantia.excepcion.url_file_name_adjunto} className="link-custom-blue d-flex align-items-center mx-2" target="_blank" rel="noreferrer">
                            <span>{props.data.detalle_garantia.excepcion.file_name_adjunto}</span>
                        </a>;
                    }
                },
            ]
        }

        // {
        //     headerName: 'Origen',
        //     field: 'detalle_garantia.origen.nombre',
        //     width: 100
        // },
        // {
        //     headerName: 'RUC',
        //     field: 'garantia.ruc',
        //     width: 100,
        //     filter: 'agTextColumnFilter',
        // },
        // {
        //     headerName: 'Razon Social',
        //     field: 'garantia.razon_social',
        //     filter: 'agTextColumnFilter',
        // },
        // {
        //     headerName: 'Banco',
        //     width: 100,
        //     field: 'detalle_garantia.banco.codigo'
        // },
        // {
        //     headerName: 'Importe',
        //     field: 'detalle_garantia.importe',
        //     type: 'rightAligned',
        //     width: 100,
        //     filter: 'agTextColumnFilter',
        //     valueFormatter: function (params) {
        //         return params.value ? `${numeral(params.value).format('0,0.00')}` : ``;
        //     },
        // },
        // {
        //     headerName: 'Moneda',
        //     field: 'garantia.moneda.codigo',
        //     width: 50,
        // },
        // {
        //     headerName: 'Nro Carta Fianza',
        //     width: 150,
        //     field: 'detalle_garantia.nro_carta_fianza',
        //     filter: 'agTextColumnFilter',
        //     cellRenderer: (props) => {
        //         if (!props.data) {
        //             return <></>;
        //         }
        //         return <a href={props.data.detalle_garantia.url_filename_carta_fianza} className="link-custom-blue d-flex align-items-center mx-2" target="_blank" rel="noreferrer">
        //             <span>{props.data.detalle_garantia.nro_carta_fianza}</span>
        //         </a>;
        //     }
        // },
        // {
        //     headerName: 'Venc.Carta Fianza',
        //     field: 'detalle_garantia.fecha_vencimiento_carta_fianza',
        //     filter: 'agDateColumnFilter',
        //     filterParams: createCustomDateFilterParams,
        //     valueFormatter: function (params) {
        //         return (params.value) ? `${moment(params.value).format("DD/MM/yyyy")}` : null;
        //     },
        //     width: 150
        // },
        // {
        //     headerName: 'Nro Operación',
        //     field: 'detalle_garantia.nro_operacion',
        //     width: 130,
        //     filter: 'agTextColumnFilter',
        // },
        // {
        //     headerName: 'Estado',
        //     field: 'detalle_garantia.estado.nombre',
        //     resizable: true,
        //     width: 180
        // }
    ], []);

    const agGridLista = useMemo(() => ({
        defaultColDef: {
            sortable: true,
            filter: true,
            resizable: true,
            minWidth: 10,
            //defaultMinWidth: 50,
            floatingFilter: true,
            // allow every column to be grouped
            enableRowGroup: true,
        },
        columnDefs: header,
        rowData: data_locatario?.data,
        pagination: true,
        paginationAutoPageSize: true,
        rowGroupPanelShow: 'always',
        rowSelection: 'single',
        domLayout: "normal",
    }), [header, data_locatario?.data]);


    //--------------------------------
    const [showGenerateModal, setShowGenerateModal] = useState(false);
    const [valueGenerateModal, setValueGenerateModal] = useState(null);
    const [reloadGrid, setReloadGrid] = useState(true);
    const user = useGetUser()
    //const [data, setData] = useState([]);

    const openGenerateModal = (props) => {
        setShowGenerateModal(true);
        setValueGenerateModal(props);
    }

    const finishGenerate = useCallback(() => {
        setReloadGrid(true);
        refetch_data_locatario();
    }, [])

    // const addMonedaToDetalle = (myData) => {
    //     for (let i = 0; i < myData.length; i++) {
    //         for (let j = 0; j < myData[i].detalle.length; j++) {
    //             myData[i].detalle[j].moneda = myData[i].garantia.moneda;
    //             myData[i].detalle[j].ruc = myData[i].garantia.ruc;
    //             myData[i].detalle[j].razon_social = myData[i].garantia.razon_social;
    //         }
    //     }
    //     return myData;
    // }

    // const getData = useCallback((ruc) => {
    //     GetGarantiasByRuc(ruc).then(response => {
    //         setData(response.data);
    //     });
    // }, [setData])

    const handleAddCartaFianza = useCallback((idGarantia) => {
        AddCartaFianza(idGarantia, user.email).then(response => {
        })
    }, [user])

    // useEffect(() => {
    //     if (data_locatario) {
    //         console.info(data_locatario, "data_locatario");
    //     }

    // }, [data_locatario])


    // useEffect(() => {
    //     console.info(session.ruc, "Session GA ======================================================");
    // }, [session])

    const breadcrumbs = [
        { title: "Inicio", path: "/locatario/dashboard", isActive: true, isSeparator: false },
        { title: "", path: "", isActive: false, isSeparator: true },
        { title: "Garantías", path: "", isActive: false, isSeparator: false },
    ];

    return (
        <>
            <PageTitle>Garantías</PageTitle>
            <CardEx titleParent={title}
                title={"Listado de Garantías"}
                breadcrumbs={breadcrumbs}
                height={"100%"}
                onRefetchTable={async () => {
                    await refetch_data_locatario();
                    cogoToast.success('Registros actualizado satisfactoriamente!', {
                        //hideAfter: 0,
                        heading: 'Listado de',
                        position: 'top-right'
                    });
                }}>
                <WrappedAgTable
                    {...agGridLista} >
                </WrappedAgTable>
            </CardEx>

            <GenerateRenovacionModal
                showModal={showGenerateModal}
                setShowModal={setShowGenerateModal}
                value={valueGenerateModal}
                onFinishService={finishGenerate}
            />
        </>
    )
}